import type { MatchMode } from '../../tables/logic/tableSearch'
import type { SearchMatchParams } from '../api/search.api'

export function getSearchMatchParams(mode: MatchMode): SearchMatchParams {
  return {
    match_type: mode.type,
    case_sensitive: mode.caseSensitive,
    whole_word: mode.wholeWord,
    exact_text: mode.exactText,
  }
}

export function getSearchMatchKey(mode: MatchMode): string {
  return [
    mode.type,
    mode.caseSensitive ? 'case' : 'nocase',
    mode.wholeWord ? 'word' : 'partial',
    mode.exactText ? 'exact' : 'folded',
  ].join(':')
}
